import {
    BoltIcon,
    CheckIcon,
    EnvelopeIcon,
    EyeIcon,
    PhoneIcon,
    ShieldCheckIcon
} from '@heroicons/react/24/outline'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import { ProgressBar } from '../../components/guided-onboarding/ProgressBar'
import { useRecoilState } from 'recoil'
import { guidedOnboardingIncompleteState } from '../../store/DomainStore'

function ConfirmationStepPage() {
    const navigate = useNavigate()

    const [showProgressBar, setShowProgressBar] = useRecoilState(guidedOnboardingIncompleteState)

    return (
        <>
            {showProgressBar && (
                <div className="max-w-xl mx-auto">
                    <ProgressBar currentStep={3} totalSteps={3} />
                </div>
            )}
            <div className="bg-white rounded-2xl p-6 md:p-8 border border-border shadow-lg max-w-xl mx-auto">
                <div className="animate-fade-in">
                    <div className="mx-auto h-14 w-14 rounded-full bg-lime-50 mb-4 flex items-center justify-center">
                        <ShieldCheckIcon className="w-8 h-8 text-lime-500" />
                    </div>
                    <div className="mb-6 text-center">
                        <h1 className="text-2xl md:text-3xl mb-3">Protection activated</h1>
                        <p className="text-base text-muted-foreground max-w-2xl mx-auto mb-4">
                            Your social media channels are now monitored 24/7.
                        </p>
                    </div>

                    <div className="space-y-3 mb-8 text-left ">
                        <div
                            className={`p-4 rounded-lg border transition-all duration-500 border-lime-400 bg-lime-400/5`}
                        >
                            <div className="flex items-center gap-3">
                                <div className="w-6 h-6 bg-lime-400 rounded-full flex items-center justify-center flex-shrink-0">
                                    <CheckIcon className="w-4 h-4 text-white" />
                                </div>
                                <div className="flex items-center gap-2">
                                    <BoltIcon className="w-4 h-4 text-primary" />
                                    <span className="font-medium text-foreground">
                                        Toxic and spam comments hidden automatically
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div
                            className={`p-4 rounded-lg border transition-all duration-500 border-lime-400 bg-lime-400/5`}
                        >
                            <div className="flex items-center gap-3">
                                <div className="w-6 h-6 bg-lime-400 rounded-full flex items-center justify-center flex-shrink-0">
                                    <CheckIcon className="w-4 h-4 text-white" />
                                </div>
                                <div className="flex items-center gap-2">
                                    <EyeIcon className="w-4 h-4 text-primary" />
                                    <span className="font-medium text-foreground">
                                        Threat comment detection active
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-4 bg-primary/5 rounded-lg border border-primary/50 mb-8 text-left ">
                        <p className="font-medium text-foreground text-sm mb-1 mt-0">
                            How to get help
                        </p>
                        <p className="text-xs text-muted-foreground mb-3">
                            If you need help at any time:
                        </p>

                        <div className="space-y-4 border-t border-primary/10 pt-3">
                            <div className="flex items-start gap-3">
                                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                                    <EnvelopeIcon className="w-5 h-5 text-primary" />
                                </div>{' '}
                                <div className="text-sm">
                                    <div className="font-medium text-foreground mb-1 text-xs">
                                        Email
                                    </div>
                                    <a
                                        href="mailto:support@arwen.ai"
                                        className="text-primary hover:underline break-all"
                                    >
                                        support@arwen.ai
                                    </a>
                                </div>
                            </div>

                            <div className="flex items-start gap-3">
                                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                                    <PhoneIcon className="w-5 h-5 text-primary" />
                                </div>{' '}
                                <div className="text-sm">
                                    <div className="font-medium text-foreground mb-1 text-xs">
                                        Call
                                    </div>
                                    <div className="space-y-1 text-muted-foreground">
                                        <div>
                                            UK:{' '}
                                            <a
                                                href="tel:+442071395083"
                                                className="text-primary hover:underline"
                                            >
                                                +44 0207 139 5083
                                            </a>
                                        </div>
                                        <div>
                                            US:{' '}
                                            <a
                                                href="tel:+18333185396"
                                                className="text-primary hover:underline"
                                            >
                                                +1 833 318 5396
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                        <Button
                            onClick={() => {
                                setShowProgressBar(false)
                                navigate(`/connect`)
                            }}
                            size="large"
                            text="Add another Profile"
                            primary
                            full
                        />
                        <Button
                            onClick={() => navigate(`/`)}
                            size="large"
                            text="Go to my Dashboard"
                            primary
                            full
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConfirmationStepPage
